import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import AdminGate from "@/components/AdminGate";
import House from "lucide-react";
import Artist from "@/pages/Artist";
import Playlists from "@/pages/Playlists";
import Compilation from "@/pages/Compilation";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import AlbumPage from "@/pages/AlbumPage";
import TrackPage from "@/pages/TrackPage";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Subscribe from "@/pages/Subscribe";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <PlayerProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/*" element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/browse" element={<Browse />} />
                    <Route path="/playlists" element={<Playlists />} />
                    <Route path="/compilation" element={<Compilation />} />
                    <Route path="/album/:id" element={<AlbumPage />} />
                    <Route path="/track/:id" element={<TrackPage />} />
                    <Route path="/subscribe" element={<Subscribe />} />
                    <Route path="/artist" element={<Artist />} />
                    <Route path="/contact" element={<Artist />} />
                    <Route path="/admin" element={<AdminGate><Admin /></AdminGate>} />
                  </Routes>
                </Layout>
              } />
            </Routes>
            <Toaster position="top-center" theme="dark" />
          </PlayerProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
